import { getDomainFromUrl } from '@opallabs/lambda'
import { Icon } from '@opallabs/lapidary'
import * as styles from './styles'

interface RedditPromotedFooterProps {
  cta?: string
  destinationUrl?: string
}

export const RedditPromotedFooter: React.FC<RedditPromotedFooterProps> = ({
  cta = 'No Button',
  destinationUrl = '',
}) => {
  const showCta = cta !== 'No Button'
  const displayDomain = getDomainFromUrl(destinationUrl)

  return (
    <div css={styles.footerWrapper}>
      {/* URL Bar Row - shows destination URL and CTA */}
      {(displayDomain || showCta) && (
        <div css={styles.urlBarRow}>
          <span css={styles.urlDisplay}>{displayDomain}</span>
          {showCta && <button css={styles.ctaButton}>{cta}</button>}
        </div>
      )}

      {/* Engagement Row - Vote, Comments, Share */}
      <div css={styles.engagementRow}>
        {/* Vote buttons */}
        <div css={styles.voteWrapper}>
          <Icon glyph="gem-reddit-upvote" css={styles.voteIcon} />
          <span css={styles.voteText}>Vote</span>
          <Icon glyph="gem-reddit-downvote" css={styles.voteIcon} />
        </div>

        {/* Comments */}
        <div css={styles.actionItem}>
          <Icon glyph="gem-reddit-comment" css={styles.actionIcon} />
          <span css={styles.actionText}>0</span>
        </div>

        {/* Share */}
        <div css={styles.actionItem}>
          <Icon glyph="gem-reddit-share" css={styles.actionIcon} />
          <span css={styles.actionText}>Share</span>
        </div>
      </div>
    </div>
  )
}
